/** Dropdown and column filters match each word, in any order, inside the option text. */
export function installSmartContainsFilter(filterService) {
  const contains = filterService?.filters?.contains;
  if (typeof contains !== 'function' || contains.smartWords) return;
  const smartContains = (value, filter, filterLocale) => {
    const text = String(filter ?? '').trim().replace(/\s+/gu, ' ');
    if (!text) return true;
    return text.split(' ').every((token) => contains(value, token, filterLocale));
  };
  smartContains.smartWords = true;
  filterService.filters.contains = smartContains;
}
